import Page from "../../components/Page";
import useStaffPage from "./hooks/useStaffPage";

const StaffPage = () => {
  const page = useStaffPage();
  return <Page {...page} />;
};

export default StaffPage;
